if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.termsCheckbox = this.querySelector(`#certificateExpire-checkbox-${this.dataset.sectionId}`);
        this.nonRefundableCheckbox = this.querySelector(`#giftnonref-checkbox-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();

      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      validateForm(e) {
        if (!this.checkboxInput.checked) {
          return true; // Gift recipient disabled, proceed normally
        }

        const errors = {}; // Saare errors collect karenge

        // Email validation
        if (!this.emailInput.value) {
          errors.email = ['Email is required'];
        }

        // Checkbox 1 validation (Expiry Terms)
        if (this.termsCheckbox && !this.termsCheckbox.checked) {
          errors.terms = ['You must accept expiry terms'];
        }

        // Checkbox 2 validation (Non-Refundable)
        if (this.nonRefundableCheckbox && !this.nonRefundableCheckbox.checked) {
          errors.nonref = ['You must agree gift is non-refundable'];
        }

        // Agar koi errors hai, toh show karo
        if (Object.keys(errors).length > 0) {
          this.displayErrorMessage('Please fix these errors', errors);
          e.preventDefault();
          e.stopImmediatePropagation();
          
          // Pehle error pe focus karo
          const firstError = this.querySelector('[aria-invalid="true"]');
          if (firstError) {
            firstError.scrollIntoView({ behavior: 'smooth', block: 'center' });
            firstError.focus();
          }
          return false;
        }

        return true;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });

        const form = this.closest('form');
        if (form) {
          form.addEventListener('submit', (e) => {
            this.validateForm(e);
          }, { capture: true }); // Capture phase mein event pakdo (important!)
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty, this.termsCheckbox, this.nonRefundableCheckbox];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
        if (this.termsCheckbox) this.termsCheckbox.checked = false;
        if (this.nonRefundableCheckbox) this.nonRefundableCheckbox.checked = false;
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        // Pehle saare existing errors clear karo
        this.clearErrorMessage();
        
        // Error message show karo
        this.errorMessageWrapper.hidden = false;
        this.errorMessage.innerText = title || this.defaultErrorHeader;

        // Har error ko individually add karo
        if (typeof body === 'object') {
          Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            
            // Error message element ko dhundho
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            if (!errorMessageElement) return;

            // Error message ko update karo
            const errorTextElement = errorMessageElement.querySelector('.error-message');
            if (errorTextElement) errorTextElement.innerText = message;
            errorMessageElement.classList.remove('hidden');

            // Field ko invalid mark karo
            const inputElement = this.querySelector(fieldSelector);
            if (inputElement) {
              inputElement.setAttribute('aria-invalid', 'true');
              inputElement.setAttribute('aria-describedby', errorMessageId);
            }
          });
        }
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
        
        // Clear error states for checkboxes
        if (this.termsCheckbox) {
          this.termsCheckbox.setAttribute('aria-invalid', false);
          this.termsCheckbox.removeAttribute('aria-describedby');
        }
        if (this.nonRefundableCheckbox) {
          this.nonRefundableCheckbox.setAttribute('aria-invalid', false);
          this.nonRefundableCheckbox.removeAttribute('aria-describedby');
        }
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
}
